// Common configuration
const CLIENT_ID = 'e4ee44b2-db97-4154-a1ea-4f266f8fec63';
const TURNSTILE_SITE_KEY = '0x4AAAAAACAmHP9eQ7hPlRng';

// API Configuration:
// - Production builds use .env.production (api.aviotrack.com)
// - Development uses fallback localhost URLs
// - IMPORTANT: .env.local must NOT override API URLs (it takes priority over .env.production)
const config = {
  CLIENT_ID,

  // API URLs - set via .env.production for production, fallback to localhost for dev
  AVIOTRACK_API_URL: process.env.REACT_APP_AVIOTRACK_API_URL || 'http://localhost:8080/aviotrack',
  AVIOTRACK_WS_URL: process.env.REACT_APP_AVIOTRACK_WS_URL || `ws://localhost:8080/aviotrack/websocket/${CLIENT_ID}`,

  // Turnstile CAPTCHA - controlled via REACT_APP_TURNSTILE_ENABLED env var
  TURNSTILE_ENABLED: process.env.REACT_APP_TURNSTILE_ENABLED === 'true',
  TURNSTILE_SITE_KEY
  // SECURITY: TURNSTILE_SECRET_KEY must NEVER be in frontend code - it belongs ONLY on the backend!
};

export default config;